<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 209.52 209.52">
        <g id="Layer_1-2" data-name="Layer 1">
            <circle cx="104.76" cy="104.76" r="100.76" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"/>
            <path d="M81,202.71c-13.67-29,16.31-49,38.9-49A63.41,63.41,0,1,0,56.53,90.28c0,25.73-30.89,40.85-48.92,41.29" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"/>
        </g>
    </svg>
</template>
